module.exports = __webpack_public_path__ + "img/c00_buildingtechironsmelting_Normal_ua.ae7035ae.webp";